import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from '../../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MonitorTab, MonitorTabList } from '../monitors.const';

declare var $: any;

@Component({
  selector: 'monitors-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.css'],
})
export class ActivitiesComponent extends BaseComponent implements OnChanges, AfterViewInit {
  @Input() dataCall: any;
  @Input() dataCallDashboard: any;
  @Input() callDaily: any;
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();
  public dataQueue = {
    chat: 0,
    call: 0,
  };
  public dataChannel = {
    facebook: 0,
    zalo: 0,
    liveChat: 0,
    email: 0,
  };
  public dataCallIn = {
    total: 0,
    miss: 0,
    answer: 0,
    reject: 0,
    avg_waiting: '00:00:00',
    avg_answer: '00:00:00',
  };
  public dataCallOut = {
    total: 0,
    miss: 0,
    answer: 0,
    reject: 0,
    miss_predictive: 0,
    avg_waiting_miss_predictive: 0,
    avg_waiting: '00:00:00',
    avg_answer: '00:00:00',
  };
  public agentInProgress: number = 0;
  public botInProgress: number = 0;
  public totalInProgress: number = 0;
  public sessionChartOptions: any = {};
  public readonly tabList = MonitorTabList;
  public readonly MonitorTab = MonitorTab;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService
  ) {
    super(changeDetector, toastr, modalService);
  }

  async ngOnInit() {}

  // async initSessionChart(data){
  //   this.sessionChartOptions ={
  //     chart: {
  //       type: 'pie',
  //       backgroundColor: null,
  //       plotBackgroundColor: null,
  //       plotBorderWidth: null,
  //       plotShadow: false,
  //       height: '50%'
  //     },
  //     responsive:true,
  //     title: {
  //       text: 'Custom Half Donut Chart'
  //     },
  //     plotOptions: {
  //       pie: {
  //         startAngle: -90,
  //         endAngle: 90,
  //         center: ['50%', '75%'],
  //         size: '200%',
  //         innerSize: '80%',
  //
  //       }
  //     },
  //     series: [{
  //       type: 'pie',
  //       name: 'Share',
  //       data: [
  //         { name: 'A', y: 30 },
  //         { name: 'B', y: 70}
  //       ]
  //     }]
  //   };

  ngOnChanges(changes: SimpleChanges): void {
    this.initData().then(data => {});
  }

  ngAfterViewInit(): void {}

  // }
  async initData() {
    if (this.dataCall) {
      const {
        totalFacebookWaiting = 0,
        totalZaloWaiting = 0,
        totalChatWaiting = 0,
        totalEmailWaiting = 0,
        totalFacebook = 0,
        totalZalo = 0,
        totalChat = 0,
        totalEmail = 0,
      } = this.dataCall.analytic;
      this.dataQueue.chat = totalFacebookWaiting + totalZaloWaiting + totalChatWaiting + totalEmailWaiting;
      this.dataChannel.facebook = totalFacebook;
      this.dataChannel.zalo = totalZalo;
      this.dataChannel.liveChat = totalChat;
      this.dataChannel.email = totalEmail;
    }

    if (this.dataCallDashboard) {
      const inboundTotal = this.dataCallDashboard.inbound.callsInQueue || 0;
      const outboundTotal = this.dataCallDashboard.outbound.callsInQueue || 0;
      this.dataQueue.call = inboundTotal + outboundTotal;
    }

    if (this.callDaily) {
      const {
        call_in = 0,
        miss_call_in = 0,
        answer_call_in = 0,
        reject_call_in = 0,
        average_time_waiting_in = '00:00:00',
        average_time_answer_in = '00:00:00',
        call_out = 0,
        miss_call_out = 0,
        answer_call_out = 0,
        reject_call_out = 0,
        miss_call_out_prd = 0,
        average_time_waiting_out_prd = '00:00:00',
        average_time_waiting_out = '00:00:00',
        average_time_answer_out = '00:00:00',
      } = this.callDaily;
      this.dataCallIn.total = call_in;
      this.dataCallIn.miss = miss_call_in;
      this.dataCallIn.answer = answer_call_in;
      this.dataCallIn.reject = reject_call_in;
      this.dataCallIn.avg_waiting = average_time_waiting_in;
      this.dataCallIn.avg_answer = average_time_answer_in;
      this.dataCallOut.total = call_out;
      this.dataCallOut.miss = miss_call_out;
      this.dataCallOut.answer = answer_call_out;
      this.dataCallOut.reject = reject_call_out;
      this.dataCallOut.miss_predictive = miss_call_out_prd;
      this.dataCallOut.avg_waiting_miss_predictive = average_time_waiting_out_prd;
      this.dataCallOut.avg_waiting = average_time_waiting_out;
      this.dataCallOut.avg_answer = average_time_answer_out;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/monitors/activities/activities.component.ts